export default __webpack_public_path__ + "static/media/default_avatar.5c1985fd.jpg";